import { render, staticRenderFns } from "./LensDescriptionCard.vue?vue&type=template&id=192e1d67&scoped=true&"
import script from "./LensDescriptionCard.vue?vue&type=script&lang=js&"
export * from "./LensDescriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./LensDescriptionCard.vue?vue&type=style&index=0&id=192e1d67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192e1d67",
  null
  
)

export default component.exports